import { ChipProps } from "@/types/component"

import "./index.scss"

import React from "react"

const Chip: React.FC<ChipProps> = ({
  avatar,
  children,
  disabled = false,
  onDelete,
  size = "medium",
  type = "default",
  variant = "filled",
}) => {
  return (
    <div
      className={`chip ${variant} ${type} ${size} ${disabled ? "disabled" : ""}`}
      onClick={onDelete ? () => onDelete() : undefined}
    >
      {avatar && <span className="chip__avatar">{avatar}</span>}
      <span className="chip__content">{children}</span>
    </div>
  )
}

export default Chip
